import React from 'react';
import Handle from './handle';
import Track from './track';
import isTouchDevice from './use-touches';
import { autobind } from 'core-decorators';

@autobind
class Slider extends React.Component {
  static defaultProps = {
    colors: ['#000'], // define your own colors instead.
    handleSize: 12,
    padX: 20, // MUST be > handleSize to avoid clip issues
    width: 400,
    height: 100,
    trackSize: 6,
    handleStrokeSize: 3,
    handleInnerDotSize: 4,
    bg: '#fff',
  };

  constructor(props) {
    super(props);

    this.state = {
      down: null,
    };
    this.rootRef = React.createRef();
  }

  step(min, max, x) {
    return Math.max(0, Math.min((x - min) / (max - min), 1));
  }

  xForEvent(e) {
    let node = this.rootRef.current;
    //let clientX = e.clientX
    let m = node.getScreenCTM();
    let p = node.createSVGPoint();
    if (isTouchDevice()) {
      // There is a bug in touch events and we need to compute the real clientX
      // http://stackoverflow.com/questions/5885808/includes-touch-events-clientx-y-scrolling-or-not
      //clientX = e.pageX; // safer to start with pageX
      let stopAt = document.body.parentElement;
      while (node && node !== stopAt) {
        //clientX -= node.scrollLeft
        node = node.parentElement;
      }
    }
    p.x = e.clientX;
    p = p.matrixTransform(m.inverse());
    return p.x;
  }

  sum() {
    return this.props.values.reduce(function (a, b) {
      return a + b;
    });
  }

  x(value) {
    let props = this.props;
    let width = props.width;
    let padX = props.padX;
    let sum = this.sum();
    return Math.round(padX + (value * (width - 2 * padX)) / sum);
  }

  reverseX(x) {
    let props = this.props;
    let width = props.width;
    let padX = props.padX;
    let sum = this.sum();
    return sum * ((x - padX) / (width - 2 * padX));
  }

  concernedEvent(e) {
    let down = this.state.down;
    if (!isTouchDevice()) {
      return e;
    } else {
      if (!down) return e.targetTouches[0];
      let touchId = down.touchId;
      let touches = e.changedTouches;
      for (let i = 0; i < touches.length; ++i) {
        if (touches[i].identifier === touchId) return touches[i];
      }
      return null;
    }
  }

  onHandleStart(i, e) {
    let event = this.concernedEvent(e);
    if (!event) return;
    e.preventDefault();
    this.setState({
      down: {
        touchId: event.identifier,
        x: this.xForEvent(event),
        controlled: i,
      },
    });
  }

  onHandleMove(e) {
    let event = this.concernedEvent(e);
    if (!event) return;
    e.preventDefault();
    let x = this.xForEvent(event);
    let valuePos = this.reverseX(x);
    let down = this.state.down;
    let values = this.props.faixa.map((c) => c.valor);
    let leftIndex = down.controlled - 1;
    let rightIndex = down.controlled;
    let leftValue = values[leftIndex];
    let rightValue = values[rightIndex];
    let w = leftValue + rightValue;
    // let offsetLeft = 0
    // for (let i=0; i<leftIndex; ++i)
    //   offsetLeft += values[i]

    let left = Math.round(valuePos); //Math.round(w * this.step(offsetLeft, offsetLeft+w, valuePos))
    let right = w - left;

    let prev = 0;
    let prevIndex = leftIndex - 1;
    if (prevIndex >= 0) prev = values[prevIndex];

    if (left < right && left > prev) {
      values = [].concat(values);
      values[leftIndex] = left;
      //values[rightIndex] = right
      this.props.onChange(values);
    }
  }

  onHandleEnd(e) {
    let event = this.concernedEvent(e);
    if (!event) return;
    this.setState({
      down: null,
    });
  }
  onHandleAbort(e) {
    let event = this.concernedEvent(e);
    if (!event) return;
    this.setState({
      down: null,
    });
  }

  render() {
    let state = this.state;
    let down = state.down;
    let props = this.props;
    let height = props.height;
    let values = props.values;
    let trackSize = props.trackSize;
    let handleSize = props.handleSize;
    let handleStrokeSize = props.handleStrokeSize;
    let handleInnerDotSize = props.handleInnerDotSize;
    let bg = props.bg;
    let centerY = height / 2;
    let touchEvents = isTouchDevice();

    let tracks = [];
    let handles = [];
    let prev = 0;
    let prevColor = bg;
    let sumValue = 0;

    let farois = this.props.faixa;

    let len = farois ? farois.length : 0;

    farois &&
      farois.map((farol, i) => {
        //let value = values[i]
        let value = farol.valor;
        let next = value;
        let fromX = this.x(prev);
        let toX = this.x(next);
        let color = farol.farol.cor;

        tracks.push(<Track key={i} color={color} y={centerY} lineWidth={trackSize} fromX={fromX} toX={toX} />);
        if (i !== 0) {
          let handleEvents = {};
          if (touchEvents) {
            if (!down) {
              handleEvents.onTouchStart = this.onHandleStart.bind(null, i);
            } else if (down.controlled === i) {
              handleEvents.onTouchMove = this.onHandleMove;
              handleEvents.onTouchEnd = this.onHandleEnd;
              handleEvents.onTouchCancel = this.onHandleAbort;
            }
          } else {
            handleEvents.onMouseDown = this.onHandleStart.bind(null, i);
          }
          handles.push(
            <Handle
              value={farois[i - 1].valor}
              key={i}
              active={down && down.controlled === i}
              x={fromX}
              y={centerY}
              bg={bg}
              color={farois[i - 1].igual ? prevColor : color}
              strokeWidth={handleStrokeSize}
              innerRadius={handleInnerDotSize}
              size={handleSize}
              events={handleEvents}
            />
          );
        }
        sumValue = sumValue + value;
        prev = value;
        prevColor = color;

        return null;
      });

    // Specific case to avoid blocking the slider.
    if (len >= 3 && values[len - 2] === 0 && values[len - 1] === 0) {
      let reverseFromIndex;
      for (reverseFromIndex = len - 1; values[reverseFromIndex] === 0 && reverseFromIndex > 0; reverseFromIndex--);
      let h1 = handles.slice(0, reverseFromIndex);
      let h2 = handles.slice(reverseFromIndex);
      h2.reverse();
      handles = h1.concat(h2);
    }
    let events = {};
    if (!touchEvents && down) {
      events.onMouseMove = this.onHandleMove;
      events.onMouseUp = this.onHandleEnd;
      events.onMouseLeave = this.onHandleAbort;
    }
    return (
      <svg ref={this.rootRef} {...events} width="100%" height="70px" viewBox={'0 0 100% ' + height}>
        {tracks}
        {handles}
      </svg>
    );
  }
}

export default Slider;
